import { generateAssetRenditionUrl, ImageFormat } from '../Utils/Assets';

export class Challenge {
  id: string;
  title: string;
  description: string;
  image?: {
    originalUrl: string;
    compressedUrl: string | null;
  } | null;
  type: ChallengeType;
  targetReadingTime: number | null;
  currentReadingTime: number;
  startsAt: Date;
  endsAt: Date;
  status: ChallengeStatus;
  readingCircleId: string;
  createdAt: Date;
  updatedAt: Date;
  deletedAt: Date | undefined;

  constructor(data: any) {
    const imageUrl =
      data.imagePath &&
      new URL(data.imagePath, window.env.REACT_APP_MEDIA_BASE_URL).toString();

    this.id = data.id;
    this.title = data.title;
    this.description = data.description;
    this.image = imageUrl && {
      originalUrl: imageUrl,
      compressedUrl: generateAssetRenditionUrl(
        imageUrl,
        null,
        ImageFormat.WEBP,
      ),
    };
    this.type = data.type;
    this.targetReadingTime = data.targetReadingTime;
    this.currentReadingTime = data.currentReadingTime;
    this.startsAt = data.startsAt && new Date(Date.parse(data.startsAt));
    this.endsAt = data.endsAt && new Date(Date.parse(data.endsAt));
    this.status = data.status;
    this.readingCircleId = data.readingCircleId;
    this.createdAt = data.createdAt && new Date(Date.parse(data.createdAt));
    this.updatedAt = data.updatedAt && new Date(Date.parse(data.updatedAt));
    this.deletedAt = data.deletedAt && new Date(Date.parse(data.deletedAt));
  }

  get readingTimeProgress(): ChallengeTargetProgress | undefined {
    if (!this.targetReadingTime) return undefined;
    return new ChallengeTargetProgress(
      this.currentReadingTime,
      this.targetReadingTime,
    );
  }
}

export enum ChallengeType {
  READING_TIME = 'READING_TIME',
}

export enum ChallengeStatus {
  ACTIVE = 'Active',
  COMPLETED = 'Completed',
  FAILED = 'Failed',
}

export class ChallengeTargetProgress {
  constructor(
    public readonly currentValue: number,
    public readonly targetValue: number,
  ) {}

  get isCompleted(): boolean {
    return this.currentValue >= this.targetValue;
  }
}

export interface ChallengeContextType {
  challenges: Challenge[];
  refreshChallenges: () => Promise<void>;
}
